import { Api } from 'utils';

class DocumentPlanService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/document-plans',params),
		save: async (params?: any) => Api.createResponse('admin/document-plans/save',params),
		saveUser: async (params?: any) => Api.createResponse('admin/document-plans/save-user',params),
		delete: async (params?: any) => Api.createResponse('admin/document-plans/delete',params),
		getPlanList: async (params?: any) => Api.createResponse('admin/document-plans/plan-list',params),
		deletePlanUser: async (params?: any) => Api.createResponse('admin/document-plans/delete-plan-user',params),
	}

}

export default DocumentPlanService;